<template>
  <div>
    <b-table-simple bordered striped>
      <b-thead>
        <b-tr>
          <b-th>{{ $store.state.form.syaratDokumen }}</b-th>
          <b-th>{{ $store.state.form.file }}</b-th>
          <b-th>{{ $store.state.form.checklist }}</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="item in kebutuhanPelamar" :key="item.kebutuhanPelamarId">
          <b-td>{{ item.namaKebutuhan }}</b-td>
          <b-td>
            <b-button variant="success" size="sm" v-if="item.fileKebutuhan != null" @click="view(item.fileKebutuhan)">{{ $store.state.form.lihatFile }}</b-button>

            <b-button v-else variant="danger" size="sm">
              {{ $store.state.form.tidakAdaFile }}
            </b-button>
          </b-td>

          <b-td>
            <b-form-checkbox v-model="item.statusKebutuhan" name="checkbox-1" value="1" unchecked-value="0"> </b-form-checkbox>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  name: "detailTabLampiran",
  props: ["kebutuhanPelamar"],
  data() {
    return {};
  },
  methods: {
    view(x) {
      let kode = this.$store.state.kode_client ? this.$store.state.kode_client : null;
      let ip = `https://${kode}.storage.googleapis.com/`;
      window.open(ip + x);
    },
  },
};
</script>
